import { render } from "./PatientIdentityFields.vue?vue&type=template&id=e48d42d2"
import script from "./PatientIdentityFields.vue?vue&type=script&lang=js"
export * from "./PatientIdentityFields.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__